import React from "react";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaw} from "@fortawesome/free-solid-svg-icons";
import {device} from "../../assets/styles/media";

const HiddenRadio = styled.input`
    display: none;
`;

const RadioLabel = styled.label`
    cursor: pointer;
    font-weight: 600;
    color: ${(props) => (props.checked ? '#f5ab18' : '#717171')};
    display: flex;
    align-items: center;
    
`;

const CustomRadioIcon = styled(FontAwesomeIcon)`
    font-size: 20px;
    margin-right: 8px;
    letter-spacing: -0.4px;
 
    ${device.mobile}{
        font-size: 16px;
    }
`;
const TextBox = styled.p`
    font-size: 15px;
    
    ${device.mobile}{
        font-size: 14px;
    }
`;


const Radio = ({value, id, checked, onChange, text}) => {
    return (
        <RadioLabel
            htmlFor={id}
            checked={checked}
        >
            <>
                <HiddenRadio
                    type="radio"
                    value={value}
                    id={id}
                    checked={checked}
                    onChange={onChange}
                />
                <CustomRadioIcon icon={faPaw}/>
            </>
            
            <TextBox>{text}</TextBox>
        </RadioLabel>
    );
};

export default Radio;
